// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__3L2m0","subtitle":"Header_subtitle__11HY3"};